// KeywordsPanel — Phase 5b-2 keywords endpoint.
// 시안 design/v3/AnalyticsPanels.jsx:375-409 의 키워드 수집 layout 따름.
// endpoint 가 단순 word/count 만 제공 — status·delta 없음. 빈도순 list.

import { Card } from '../../primitives';
import {
  EmptyState,
  ErrorState,
  LoadingState,
  SectionHead,
  ShareBar,
} from '../bits';
import { useKeywords, type AnalyticsScope } from '../queries';
import { fmtNum } from '../../../lib/format';

interface Props {
  scope: AnalyticsScope;
}

export function KeywordsPanel({ scope }: Props) {
  const q = useKeywords(scope);
  const items = q.data ?? [];
  const maxCount = Math.max(1, ...items.map((k) => k.count));

  return (
    <Card style={{ padding: 20 }}>
      <SectionHead
        title="키워드 수집"
        sub={items.length ? `${items.length}건 · 메뉴명 토큰` : '수집된 키워드 없음'}
      />
      {q.isLoading && <LoadingState />}
      {q.isError && <ErrorState message={(q.error as Error).message} />}
      {q.data && items.length === 0 && (
        <EmptyState
          title="아직 수집된 키워드가 없습니다"
          message="기간 내 매출이 누적되면 메뉴명 토큰이 표시됩니다."
        />
      )}
      {items.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {items.map((k) => (
            <div
              key={k.word}
              style={{
                display: 'grid',
                gridTemplateColumns: '1.2fr 1.6fr 0.5fr',
                alignItems: 'center',
                gap: 10,
                padding: '8px 10px',
                borderBottom: '1px solid var(--border-weak)',
              }}
            >
              <span
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: 'var(--fg-1)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {k.word}
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <ShareBar value={k.count} max={maxCount} />
              </div>
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: 'var(--fg-1)',
                  fontVariantNumeric: 'tabular-nums',
                  textAlign: 'right',
                }}
              >
                {fmtNum(k.count)}회
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
